import { SVGProps } from 'react'
const MyProjectIcon = ({ className, ...props }: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={56}
    height={49}
    fill="none"
    className={className}
    {...props}
  >
    <path
      fill="#fff"
      d="M3.424 3.424h42.78v12.624c1.232.183 2.373.595 3.423 1.165v-15.5C49.627.755 48.874 0 47.914 0H1.713A1.71 1.71 0 0 0 0 1.713v39.014c0 .96.775 1.713 1.713 1.713h29.29l.387-3.197c0-.068.022-.16.046-.229H3.424V3.424Z"
    />
    <path
      fill="#fff"
      d="M44.651 33.185a6.914 6.914 0 1 0 .003-13.828 6.914 6.914 0 0 0-.003 13.828ZM54.508 39.653a7.322 7.322 0 0 0-3.415-5.36c-1.773 1.426-3.994 2.316-6.44 2.316s-4.667-.89-6.44-2.316a7.328 7.328 0 0 0-3.418 5.354l-.662 5.51c-.125 1.044.554 2.038 1.584 2.247 2.825.57 5.825.871 8.934.871 3.108 0 6.106-.3 8.934-.871 1.032-.209 1.71-1.203 1.584-2.247l-.662-5.502.002-.002ZM41.075 11.972c0-.946-.767-1.713-1.713-1.713H21.777a1.713 1.713 0 0 0 0 3.426h17.585c.946 0 1.713-.767 1.713-1.713ZM31.958 19.506h-10.18a1.713 1.713 0 0 0 0 3.426h10.18a1.713 1.713 0 0 0 0-3.426ZM30.436 28.751h-8.659a1.713 1.713 0 0 0 0 3.426h8.659a1.713 1.713 0 0 0 0-3.426ZM11.249 15.199a1.713 1.713 0 0 0 2.421 0l4.035-4.034a1.712 1.712 0 0 0-2.422-2.422l-2.823 2.823-.972-.974a1.713 1.713 0 0 0-2.422 2.422l2.183 2.183v.002ZM9.066 22.261l2.183 2.183a1.713 1.713 0 0 0 2.421 0l4.035-4.034a1.712 1.712 0 0 0-2.422-2.422l-2.823 2.823-.972-.974a1.713 1.713 0 0 0-2.422 2.422v.002ZM9.066 31.508l2.183 2.183a1.713 1.713 0 0 0 2.421 0l4.035-4.034a1.712 1.712 0 0 0-2.422-2.422l-2.823 2.823-.972-.971a1.713 1.713 0 0 0-2.422 2.421Z"
    />
  </svg>
)
export default MyProjectIcon
